import React from "react";
import type { TypographyProps } from "@mui/joy";
import { Typography } from "@mui/joy";
import { textTokens } from "../../styles/globalStyles";

interface DarkTypographyProps extends TypographyProps {
  children: React.ReactNode;
  colorVariant?: "primary" | "secondary" | "accent" | "muted" | "title" | "legend" | "onLight";
}

export default function DarkTypography({
  children,
  colorVariant = "primary",
  sx = {},
  ...props
}: DarkTypographyProps) {
  const getColor = () => {
    switch (colorVariant) {
      case "accent":
      case "title":
      case "legend":
        return textTokens.color.title;
      case "secondary":
        return textTokens.color.secondary;
      case "muted":
        return textTokens.color.muted;
      case "onLight":
        return textTokens.color.bodyOnLight;
      case "primary":
      default:
        return textTokens.color.bodyOnDark;
    }
  };

  return (
    <Typography
      {...props}
      sx={{
        color: getColor(),
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
